import {css} from '@emotion/css';
import {colours, spacing} from '@fo/shared/styles/variables';
import {IconColour} from './types';

const getIconColourCSS = (iconColour?: IconColour): string => {
  switch (iconColour) {
    case IconColour.BLUE:
      return `color: ${colours.brand.SECONDARY};`;
    case IconColour.YELLOW:
      return `color: ${colours.brand.PRIMARY};`;
    case IconColour.INSIGHTS:
      return `color: ${colours.brand.INSIGHTS};`;
    default:
      return '';
  }
};

export default {
  container: css`
    label: checkpointItem;
    display: flex;
    align-items: center;
    margin-bottom: ${spacing.XXS};
  `,
  icon: (iconColour?: IconColour): string => css`
    label: checkpointItem__icon;
    flex: 0 0 auto;
    align-self: flex-start;
    width: 2.5rem;
    height: 2.5rem;
    margin-right: ${spacing.XS};
    ${getIconColourCSS(iconColour)};
  `,
  title: css`
    label: checkpointItem__title;
    margin: 0.4rem 0 ${spacing.XXS}; // stylelint-disable-line sh-waqar/declaration-use-variable
  `,
  content: css`
    label: checkpointItem__content;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    p:last-child {
      margin: 0;
    }
  `,
};
